import {getNextIncompleteModuleID} from 'hec/builder/helpers/learningCenterHelpers'

const getLevels = (goalData, sfccLevels = []) => {
    const builderLevels = goalData?.levels
    return builderLevels?.map((builderLevel, levelIndex) => {
        const levelData = builderLevel.level?.value?.data
        const sfccLevel = sfccLevels.find((_sfccLevel) => _sfccLevel.id === levelData.id)
        const sfccModules = sfccLevel?.modules || []

        const completeModulesQty =
            sfccModules.length > 0
                ? sfccModules.reduce(
                      (totalModules, module) => totalModules + (module?.complete ? 1 : 0),
                      0
                  )
                : 0
        const builderModules = levelData?.modules
        const totalModules = builderModules?.length
        const nextModuleID = getNextIncompleteModuleID(levelData, sfccLevel)
        const nextModuleData = nextModuleID
            ? builderModules.find(({module}) => module.data.id === nextModuleID)
            : null
        const nextModuleUrl = nextModuleData ? nextModuleData.module.data.page.value.data.url : ''
        const firstModuleUrl = builderModules[0].module.data.page.value.data.url

        return {
            loyaltyactionId: builderLevel?.loyaltyactionId || levelData?.loyaltyActionId || null,
            parentGoalID: goalData.id,
            levelID: levelData?.id,
            levelNumber: levelIndex + 1,
            complete: totalModules === completeModulesQty,
            started: !!sfccLevel?.start,
            allModulesQty: totalModules,
            nextModuleID: nextModuleID,
            nextModuleUrl: nextModuleUrl,
            firstModuleUrl: firstModuleUrl,
            completeModulesQty: completeModulesQty,
            percentComplete: totalModules > 0 ? (completeModulesQty / totalModules) * 100 : 0
        }
    })
}

const createGoalBanner = (goalData, sfccGoal) => {
    return {
        title: goalData?.title,
        description: goalData?.description,
        image: goalData?.image,
        levels: getLevels(goalData, sfccGoal?.levels)
    }
}

export default createGoalBanner
